import { createSelector } from 'reselect';
import { isEmpty } from 'lodash';

const influencerItemSelector = item => item;

const mapTopTenFilters = filters => ([{
  condition: 'or',
  group: filters.map(f => ({
    field: f.field,
    value: f.value,
    operator: f.operator,
  })),
}]);

const filtersSelector = createSelector(
  influencerItemSelector,
  item => (!isEmpty(item)
    ? mapTopTenFilters([
      ...item.page.topTen.filters || [],
      ...item.page.topTen.selectedProductsFilters || [],
    ])
    : []),
);

export const topTenMappedFiltersSelector = createSelector(
  filtersSelector,
  mappedFilters => (mappedFilters),
);

export default {
  topTenMappedFiltersSelector,
};
